import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  // Sem padding - já fica dentro do Container do GraphicPreview, que tem seu
  // próprio padding (ver GraphicPreview/styles.js); manter os dois criava uma
  // "caixa dentro de caixa" com espaço em branco sobrando nas bordas.
  background-color: ${theme.colors.white.Branco};
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  // Sem gap - era o espaço entre o título "Janela de pulverização" e a tira
  // de pastilhas logo abaixo.
  gap: 0;

  @media (max-width: 760px) {
    // 100% (não mais largura fixa de 640px) - a tira não deve mais rolar
    // horizontal no mobile, só espremer (cada pastilha, flex:1 - ver
    // ChipSlot - encolhe pra caber). Só a fileira dos 5 cards de previsão
    // (ContainerPreviewDay, ver GraphicPreview/styles.js) rola horizontal.
    width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;


export const DetailsButton = styled.button`
  background: none;
  border: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-radius: 0.375rem;
  padding: 0.25rem 0.75rem;
  cursor: pointer;
  font-family: "Lato", sans-serif;
  font-size: 0.6875rem;
  font-weight: 700;
  color: ${theme.colors.green.Verde_AgroReceita};
  white-space: nowrap;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: ${theme.colors.green.Fundo};
  }
`;

// Tira horizontal única (sem grade dia x hora) - cada hora disponível vira
// uma pastilha colorida, em sequência cronológica, com o dia da semana
// aparecendo só uma vez, junto da primeira hora daquele dia.
export const StripWrapper = styled.div`
  width: 100%;
`;

// Pastilhas, linha de eixo e rótulos ficam em três fileiras empilhadas (em vez
// de cada pastilha+rótulo juntos numa coluna) pra linha de eixo sair contínua
// de ponta a ponta - um border-top por coluna ficaria cortado nos espaços
// (gap) entre uma coluna e outra.
// Largura 100% (em vez de max-content) - as pastilhas (ver ChipSlot) encolhem
// pra se dividir igualmente nessa largura, então a tira inteira já aparece sem
// precisar de scroll horizontal.
export const Strip = styled.div`
  width: 100.5%;
  display: flex;
  flex-direction: column;
  // Alinha as colunas de hora com o eixo X dos gráficos de Temperatura/Vento/
  // Umidade/Chuva (ver GraphicPreview/index.js): lá a área do gráfico começa
  // depois do eixo Y (width={28}) e termina antes do margin.right (5px) do
  // AreaChart - sem esse mesmo respiro aqui, a mesma hora cai em posições
  // diferentes na tira e no gráfico.
  padding: 0 0px 0 20px;
`;

export const ChipsRow = styled.div`
  display: flex;
  height: 30px;
  // "flex-end": as pastilhas ficam encostadas embaixo (coladas na risca/rótulos
  // logo abaixo), e o espaço de 50px sobra todo pra cima - é pra lá que o
  // crescimento no hover (scaleY) se expande, sem empurrar a risca/rótulos.
  align-items: flex-end;
  gap: 2px;
`;

export const AxisLine = styled.div`
  height: 1px;
  background-color: ${theme.colors.gray.Cinza_2};
  margin-top: 0.25rem;
`;

export const LabelsRow = styled.div`
  display: flex;
  align-items: flex-start;
  // Mesmo gap do ChipsRow - precisa bater coluna a coluna (número embaixo da
  // pastilha correspondente).
  gap: 2px;
`;

// Largura flexível (flex:1, em vez de fixa) pra pastilha e número do rótulo
// ficarem alinhados verticalmente - centraliza o conteúdo (display:flex +
// justify-content:center). Todas as colunas dividem igualmente a largura da
// Strip, então a tira inteira cabe sem precisar de scroll horizontal. Na
// fileira de rótulo, o filho é o HourWrap (ver abaixo): como o nome do dia
// fica fora do fluxo (position:absolute), só a largura do número conta pra
// centralização - o número fica sob a pastilha dele independente de ter ou
// não nome do dia junto.
export const ChipSlot = styled.div`
  // flex:1 (não largura fixa) - precisa dividir igualmente a largura real do
  // Strip/AxisLine (100% do container), senão a fileira de quadrados (agora
  // com largura própria, soma de cada slot) sai dessincronizada do traço do
  // eixo, que continua ocupando a largura inteira do container.
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

// Traço fino ligando a risca do eixo ao rótulo (um por coluna, primeiro filho
// do ChipSlot na fileira de rótulos) - ocupa o espaço que antes era margin da
// AxisLine (por isso ela só tem margin-top agora), então a altura é a mesma.
export const Tick = styled.div`
  width: 1px;
  height: 0.25rem;
  background-color: ${theme.colors.gray.Cinza_2};
`;

// Exportado - reaproveitado no tooltip de cada pastilha (ver index.js) pra
// colorir a bolinha de cada métrica (Temperatura, Vento, etc.) com o mesmo
// verde/amarelo/vermelho da pastilha.
export const STATUS_COLORS = {
  green: "#2FBB69",
  yellow: "#F8C84B",
  red: "#FF5252",
  empty: "#E9ECF0",
};

// O tooltip de cada pastilha é o Tippy (@tippyjs/react, theme="light"/arrow/fade),
// o mesmo já usado em outros pontos do sistema (ver farm-header/index.js,
// homologButtonHistory.js) - não precisa de CSS próprio aqui.
export const Chip = styled.div`
  width: 100%;
  height: 18px;
  border-radius: 3px;
  background-color: ${(props) => STATUS_COLORS[props.status] || STATUS_COLORS.empty};
  opacity: ${(props) => (props.status === "empty" ? 0.4 : 1)};
  transition: opacity 0.15s, transform 0.15s;
  cursor: pointer;
  position: relative;
  // Cresce ancorado embaixo (não no centro) - a base fica fixa, colada na
  // risca/rótulos, e só a parte de cima sobe pro espaço vazio da ChipsRow.
  transform-origin: bottom;

  // transform, não height: height reflui os irmãos (risca do eixo e rótulos
  // descem junto), transform só altera o visual, sem empurrar nada.
  // 24px -> 32px = escala 4/3.
  &:hover {
    transform: scaleY(1.5);
    z-index: 1;
  }
`;

// Só embrulha o número da hora - a largura natural dele (sem o nome do dia,
// que é posicionado fora do fluxo) é o que o ChipSlot centraliza.
export const HourWrap = styled.span`
  position: relative;
  display: inline-block;
  white-space: nowrap;
  font-family: "Lato", sans-serif;
  font-size: 0.625rem;

  // No mobile, menor - com só 1 rótulo a cada 6h (00h/06h/12h/18h, ver
  // index.js) ainda sobra pouco espaço por rótulo (a largura da coluna é
  // dividida por TODOS os pontos de 3h, com ou sem texto).
  @media (max-width: 768px) {
    font-size: 0.5rem;
  }
`;

export const ChipLabelHour = styled.span`
  font-weight: 600;
  color: ${theme.colors.gray.Cinza_2};
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 6rem;

  p {
    font-family: "Lato", sans-serif;
    font-size: 0.75rem;
    color: ${theme.colors.gray.Cinza_7};
    margin: 0;
  }
`;

// Bolinha colorida (verde/amarelo/vermelho) usada tanto na linha de status
// geral ("Janela de pulverização") quanto em cada métrica isolada do tooltip
// (ver montarTooltip em index.js).
export const TooltipBullet = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  min-width: 8px;
  border-radius: 2px;
  background-color: ${(props) => props.color};
`;

export const TooltipStatusRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
`;

// Separa a linha de status geral ("Janela de pulverização") da lista de
// métricas logo abaixo (ver montarTooltip em index.js).
export const TooltipDivider = styled.hr`
  width: 100%;
  height: 1px;
  margin: 8px 0;
  border: none;
  background-color: ${theme.colors.gray.Cinza_11};
`;

export const TooltipMetrics = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TooltipMetricRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const TooltipMetricLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;
